<template>
 <span> {{ days | twoDigits }}</span>
</template>

<script>
let interval = null
export default {
  name: 'vuejsCountDown2',
  props: {
    deadline: {
      type: String
    },
    end: {
      type: String
    },
    stop: {
      type: Boolean
    }
  },
  data () {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: null,
      diff: 0
    }
  },
  created () {
    if (!this.deadline && !this.end) {
      throw new Error("Missing props 'deadline' or 'end'")
    }
    let endTime = this.deadline ? this.deadline : this.end
    this.date = Math.trunc(Date.parse(endTime.replace(/-/g, '/')) / 1000)
    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline' or 'end'")
    }
    interval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    }, 1000)
  },
  computed: {
    seconds () {
      return Math.trunc(this.diff) % 60
    },
    minutes () {
      return Math.trunc(this.diff / 60) % 60
    },
    hours () {
      return Math.trunc(this.diff / 60 / 60) % 24
    },
    days () {
      return Math.trunc(this.diff / 60 / 60 / 24)
    }
  },
  watch: {
    now (value) {
      this.diff = this.date - this.now
      if (this.diff <= 0 || this.stop) {
        this.diff = 0
        // Remove interval
        clearInterval(interval)
      }
    }
  },
  filters: {
    twoDigits (value) {
      return value.toString()
    }
  },
  destroyed () {
    clearInterval(interval)
  }
}
</script>




// WEBPACK FOOTER //
// Countdown2.vue?c502f71a